import type { TFunction } from 'i18next';
import { formatDate } from '../../../lib/format';
import type { Schedule } from '../api';

/** "Mi, 01.05.2027 – 30.09.2027" – the schedule of a market in one line. */
export function scheduleText(t: TFunction, s: Schedule): string {
  const short = t('sales.markets.weekdayShort', { returnObjects: true }) as string[];
  const days = [...(s.weekdays ?? [])]
    .sort((a, b) => a - b)
    .map((n) => short[n - 1])
    .join(', ');
  const from = formatDate(s.from);
  const to = formatDate(s.to ?? s.from);
  if (s.kind === 'single') return t('sales.markets.schedule.single', { date: from });
  if (s.kind === 'range') {
    return days
      ? t('sales.markets.schedule.rangeDays', { from, to, days })
      : t('sales.markets.schedule.range', { from, to });
  }
  const every = s.every_weeks ?? 1;
  return every > 1
    ? t('sales.markets.schedule.recurringEvery', { count: every, days, from, to })
    : t('sales.markets.schedule.recurring', { days, from, to });
}

/** "08:00 – 13:00 Uhr" or `null` without times. */
export function timesText(
  t: TFunction,
  startsAt: string | null | undefined,
  endsAt: string | null | undefined,
): string | null {
  if (!startsAt) return null;
  const from = startsAt.slice(0, 5);
  return endsAt
    ? t('sales.market.times', { from, to: endsAt.slice(0, 5) })
    : t('sales.market.timeFrom', { from });
}
